module.exports = __webpack_public_path__ + "static/media/logo-aspecir.bd56ea71.png";